import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import './assets/css/main.css';

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import GoBluetoothClient from './GoBluetoothClient';

const GoConnect = new GoBluetoothClient();
GoConnect.init();
GoConnect.disconnectCallback = () => {
    router.push({ name: 'welcome' });
};

const app = createApp(App);

app.use(router);

app.provide('GoConnect', GoConnect);
app.mount('#app');
